import {
  getAffiliateDistancePrices,
  postAffiliateDistancePrice,
  putAffiliateDistancePrice,
} from '../../../Api/services/backoffice';

export const key = 'pricePerDistance';

const entityName = {
  singular: 'Preço por Distância',
  plural: 'Preços por Distância',
};

const queries = {
  list: { key, fn: getAffiliateDistancePrices },
  detail: { key },
};

const mutations = {
  create: postAffiliateDistancePrice,
  update: putAffiliateDistancePrice,
};

const fields = {
  table: [
    { key: 'affiliateDto.name', label: 'Filial' },
    { key: 'maxDistanceKm', label: 'Distância Máxima (km)' },
    { key: 'pricePerKm', label: 'Preço por km excedido (R$/m³)' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
